import { UseRadioGroupReturn } from '@chakra-ui/react';
import { createContext } from '@chakra-ui/react-utils';

export interface SegmentedControlContextType {
  getRadioProps: UseRadioGroupReturn['getRadioProps'];
  isGroupDisabled?: boolean;
}
export const [SegmentedControlContext, useSegmentedControlContext] = createContext<SegmentedControlContextType>();
